export default __webpack_public_path__ + "static/media/MarinSamardzic_dev_CV.9bed3b72.docx";